// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__xq-Lr","hidden":"Logo_hidden__UxBKk","landscape":"Logo_landscape__Yp6fm"};